import React, { useState, useEffect } from "react";
import HorizontalProgressBar from "./HorizontalProgressBar"; // Adjust the import path based on your project structure
import { Card } from '@mui/material';
import PrimaryButton from "../common/PrimaryButton";


const FlashSaleCard = ({ card }) => {

    const [timeLeft, setTimeLeft] = useState({ h: 1, m: 42, s: 17 });
    const [selectedProduct, setSelectedProduct] = useState(null);

    useEffect(() => {
        setSelectedProduct(card.cardData[0]);
        const timer = setInterval(() => {
            setTimeLeft(prev => {
                const newSeconds = prev.s - 1;
                if (newSeconds >= 0) return { ...prev, s: newSeconds };

                const newMinutes = prev.m - 1;
                if (newMinutes >= 0) return { h: prev.h, m: newMinutes, s: 59 };

                const newHours = prev.h - 1;
                if (newHours >= 0) return { h: newHours, m: 59, s: 59 };

                return { h: 0, m: 0, s: 0 };
            });
        }, 1000);
    }, []);

    const convertToHMS = (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const remainingSeconds = seconds % 60;

        return { h: hours, m: minutes, s: remainingSeconds };
    };

    const handleProductClick = (product) => {
        setSelectedProduct(product);
        setTimeLeft(convertToHMS(product.data.timeLeft));
    };

    const productDetailNavigation = (product) => {
        const currentQueryParams = window.location.search;

        // productId ko localStorage mein daal diya
        localStorage.setItem("productId", product.data.productId);

        // Clean URL, productId query params mein mat bhej
        window.location.href = `/product_detail_page${currentQueryParams}`;
    };

    return (
        <div className="p-3 row-12" >
            <h2 className="text-lg font-semibold mb-2" style={{ color: "#681517" }}>{card?.cardMetaData?.title}</h2>
            <Card width="100%"
                onClick={() => productDetailNavigation(selectedProduct)}
                className="mb-2"
                sx={{ borderRadius: "20px", padding: "16px", background: "linear-gradient(to top, #fff 0%, rgba(255, 152, 0, 0.2 ) 100%)", boxShadow: "0px 2px 4px #681517" }}
            >
                <div className="flex flex-col items-center">
                    <img
                        height="100px"
                        width="auto"
                        src={
                            selectedProduct?.data?.productImageUrl
                                ? selectedProduct.data.productImageUrl[0]
                                : ""
                        }
                        alt="Flash Sale Product"
                        className="w-48 h-48 object-contain mb-2 rounded-xl"
                    />
                    <div className="text-center">
                        <div className="text-2xl font-bold text-red-600 mb-2">
                            {String(timeLeft.h).padStart(2, "0")}H:{" "}
                            {String(timeLeft.m).padStart(2, "0")}M:{" "}
                            {String(timeLeft.s).padStart(2, "0")}S
                        </div>
                        <h3
                            style={{
                                marginLeft: "10px",
                                marginRight: "10px",
                                textAlign: "left",
                                fontSize: "16px",
                                color: "#681517"
                            }}
                            className="font-semibold mb-2"
                        >
                            {selectedProduct?.data?.productTitle}
                        </h3>
                        <div
                            style={{ marginLeft: "10px", marginRight: "10px", fontSize: "16px" }}
                            className="flex items-center justify-center gap-2 mb-2"
                        >
                            <span className="text-gray-500 line-through">
                                ₹{selectedProduct?.data?.actualPrice}
                            </span>
                            <span className="font-bold" style={{ color: "#681517" }}>
                                ₹{selectedProduct?.data?.finalPrice}
                            </span>
                            <span className="" style={{ color: "#FF9800" }}>
                                {selectedProduct?.data?.saveText}
                            </span>
                        </div>
                        <HorizontalProgressBar
                            progress={selectedProduct?.data?.soldPercentage}
                            label="Claimed"
                        />
                        {/* <button
                            style={{ marginBottom: "10px", fontSize: "16px", border: '0px' }}
                            className=" text-white px-8 py-2 rounded-full"
                        >
                            {selectedProduct?.data?.buyButtonText}
                        </button> */}
                        <PrimaryButton label={selectedProduct?.data?.buyButtonText} sx={{ width: "45%" }} />
                    </div>
                </div>
            </Card>
            <div
                className="flex overflow-x-auto gap-3 scrollbar-hide"
                style={{ paddingBottom: "8px", paddingTop: "3px" }}
            >
                {card?.cardData.map((product, index) => (
                    <div
                        height="100px"
                        width="100px"
                        style={{
                            margin: '5px',
                            borderRadius: "20px",
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                            marginRight: "2px",
                        }}
                        key={index}
                        onClick={() => handleProductClick(product)}
                    >
                        <img
                            height="100px"
                            width="100px"
                            style={{ borderRadius: "20px" }}
                            src={
                                product?.data?.productImageUrl
                                    ? product.data.productImageUrl[0]
                                    : ""
                            }
                            alt={product?.data?.productTitle}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FlashSaleCard;
